import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61c5a68f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course-information" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "course-information-title" }, "Current Course information", -1))
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-label" }, "Course: ", -1))
const _hoisted_7 = { class: "field-value" }
const _hoisted_8 = {
  key: 0,
  class: "field"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-label" }, "Start: ", -1))
const _hoisted_10 = { class: "field-value" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "Class: ", -1))
const _hoisted_14 = { class: "field-value" }
const _hoisted_15 = {
  key: 0,
  class: "field"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "Grad: ", -1))
const _hoisted_17 = { class: "field-value" }

import { Class } from '../../models/Class';
import { Course } from '../../models/Course';
import { formatDate_DD_MMM_YYYY } from '../../utils/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassInformationOverview',
  props: {
    course: null,
    _class: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(__props.course.courseName), 1)
        ]),
        (__props._class.startDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(formatDate_DD_MMM_YYYY)(__props._class.startDate as Date)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(__props._class.name), 1)
        ]),
        (__props._class.endDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(formatDate_DD_MMM_YYYY)(__props._class.endDate as Date)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})